module.exports = {"110116001":"泉河街道","110116002":"龙山街道","110116003":"怀柔地区","110116004":"雁栖地区","110116005":"庙城地区","110116102":"北房镇","110116103":"杨宋镇","110116105":"桥梓镇","110116106":"怀北镇","110116107":"汤河口镇","110116108":"渤海镇","110116109":"九渡河镇","110116110":"琉璃庙镇","110116111":"宝山镇","110116211":"长哨营满族乡","110116213":"喇叭沟门满族乡","110116400":"北京雁栖经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110116.json
// module id = 34
// module chunks = 0